import script from "./PieChartCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PieChartCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__